import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FloatingElements } from './FloatingElements';
import { AlertTriangleIcon } from 'lucide-react';
function AnimatedNumber({
  target,
  suffix = ''
}: {
  target: number;
  suffix?: string;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  useEffect(() => {
    if (!isInView) return;
    const duration = 1500;
    const startTime = performance.now();
    function animate(currentTime: number) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(eased * target));
      if (progress < 1) requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
  }, [isInView, target]);
  return <span ref={ref} className="tabular-nums" data-id="element-219">
      {count}
      {suffix}
    </span>;
}
export function Results() {
  return <section className="bg-dark py-20 md:py-32 px-5 relative overflow-hidden" data-id="element-220">
      <div className="absolute inset-0 bg-radial-money" aria-hidden="true" data-id="element-221" />
      <FloatingElements count={8} variant="money" data-id="element-222" />

      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-223">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-224">
          <div className="mb-8" data-id="element-225">
            <span className="font-display text-7xl md:text-8xl font-extrabold text-gradient-money" data-id="element-226">
              <AnimatedNumber target={30} data-id="element-227" />
            </span>
            <p className="font-display text-xl md:text-2xl font-bold text-white/60 mt-2 uppercase tracking-wider" data-id="element-228">
              Días
            </p>
          </div>

          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white leading-tight mb-8" data-id="element-229">
            Qué puede cambiar
          </h2>

          <p className="font-sans text-white/40 text-lg leading-relaxed mb-4" data-id="element-230">
            No te voy a vender fantasías. Son niños.
          </p>
          <p className="font-sans text-white/70 text-lg leading-relaxed mb-8" data-id="element-231">
            Con un sistema consistente, las discusiones bajan, la negociación se
            corta, y tu hijo empieza a pensar en{' '}
            <span className="text-money font-semibold" data-id="element-232">decisión</span> y no en{' '}
            <span className="text-money font-semibold" data-id="element-233">impulso</span>.
          </p>

          {/* Urgency */}
          <div className="inline-flex items-center gap-2 text-urgency/80 font-sans text-sm" data-id="element-234">
            <AlertTriangleIcon className="w-4 h-4" data-id="element-235" />
            <span data-id="element-236">
              Cada día que pasa sin sistema, el patrón se hace más difícil de
              romper.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}